module.exports = __webpack_public_path__ + "static/media/sitemap.6839b7c2.xml";